import request from '@/libs/http/index'
import type {
  ChargePatientSearchParams,
  PaymentChannelItem,
} from '../types/charge'

// 获取收费相关设置
export const getChargeSettings = () => {
  return request.get({
    url: '/clinic/settings-charge/get',
  })
}

// 收费页面患者信息搜索
export const chargePatientSearch = (
  params: ChargePatientSearchParams
): Promise<any> => {
  return request.get({
    url: `/clinic/medical-records/left-column`,
    params,
  })
}

// 获取收费详情
export const getChargeDetail = (id: string | number): Promise<any> => {
  return request.get({
    url: `/clinic/medical-records/get-charge-detail?id=${id}`,
  })
}

// 挂单
export const registration = (id: string | number) => {
  return request.get({
    url: `/clinic/medical-records/registration?id=${id}`,
  })
}

// 计算金额
export const calculateAmount = (params: {
  medicalRecordId: number
  list: Array<{
    id: number
    isAll: boolean
    itemIds: number[]
  }>
  memberLevelId?: number
  memberCardId?: number
  selfSelectionIds?: number[]
}) => {
  return request.put({
    url: '/clinic/medical-records/calculate',
    data: params,
  })
}

// 完成收费
export const charge = (params: {
  medicalRecordId: number
  list: Array<{
    id: number
    isAll: boolean
    itemIds: number[]
  }>
  memberLevelId?: number
  memberCardId?: number
  selfSelectionIds?: number[]
  paymentList: PaymentChannelItem[]
  memberLevelPassword?: string
  authCode?: string
  remark?: string
}) => {
  return request.put({
    url: '/clinic/medical-records/charge',
    data: params,
  })
}

// 根据会员卡号获取会员列表
export const getPatientLevelListByCardNo = (cardNo: string) => {
  return request.get({
    url: `/clinic/patient-level/get-list-by-cardNo`,
    params: { cardNo },
  })
}

// 根据手机号获取患者卡项列表
export const getPatientCardListByMobile = (mobile: string) => {
  return request.get({
    url: `/clinic/patient-card/get-list-by-mobile`,
    params: { mobile },
  })
}

// 根据ID获取患者卡项信息
export const getPatientCardById = (id: string | number) => {
  return request.get({
    url: `/clinic/patient-card/get`,
    params: { id },
  })
}

// 根据ID获取患者会员信息
export const getPatientLevelById = (id: string | number) => {
  return request.get({
    url: `/clinic/patient-level/get`,
    params: { id },
  })
}

// 删除收费项目
export const deleteChargeItem = (id: string | number) => {
  return request.delete({
    url: `/clinic/medical-charges/delete?id=${id}`,
  })
}

// 删除收费明细
export const deleteChargeDetail = (params: {
  id: string | number
  type: number
  itemId: string | number
}) => {
  return request.delete({
    url: `/clinic/medical-charges/delete-item`,
    params,
  })
}

// 新增收费项目
export const addChargesProject = (data: {
  id: number
  processing?: {
    id?: number
    prescriptionId?: number
    processingId?: number
    quantity: number
    processingNotes?: string
  }
  extraList?: Array<{
    id: number
    medicalRecordId?: number
    extraId?: number
    extraName?: string
    unitPrice: number
    totalPrice: number
    payPrice?: number
    levelDiscount: number
    cardDiscount?: number
    negotiatedDiscount?: number
    discountPrice?: number
    quantity: number
    refundGoodsNum?: number
    refundNum?: number
    refundPrice?: number
    tollNotes?: string
    tollStatus?: boolean
    remark?: string
    deptId?: number
    deptName?: string
  }>
  deliveries?: {
    id: number
    prescriptionIds?: number[]
    shippingAddress: string
    courierCompany?: string
    paymentMethod?: number
    trackingNumber?: string
    recipientName: string
    phoneNumber: string
    totalPrice: number
    payPrice?: number
    levelDiscount: number
    cardDiscount?: number
    negotiatedDiscount?: number
    discountPrice?: number
    quantity: number
    refundGoodsNum?: number
    refundNum?: number
    refundPrice?: number
    tollNotes?: string
    tollStatus?: boolean
    remark?: string
    deptId?: number
    deptName?: string
  }
  registrationFee?: number
}) => {
  return request.post({
    url: `/clinic/medical-records/add-charges-project`,
    data,
  })
}

// 更新收费项目
export const updateChargeItem = (params: {
  id: number
  itemId?: number
  count: number
}) => {
  return request.put({
    url: `/clinic/medical-charges/update`,
    data: params,
  })
}

// 更新处方收费备注
export const updateChargeItemRemark = (params: {
  id: number
  itemId?: number
  tollNotes: string
}) => {
  return request.put({
    url: `/clinic/medical-charges/update-remark`,
    data: params,
  })
}

// 获取收费记录
export const getChargeRecords = (params: {
  pageSize?: number
  medicalRecordId: number | string
}) => {
  return request.get({
    url: '/clinic/charges-records/page',
    params,
  })
}

// 获取收费记录-打印用
export const getChargeRecordsPrint = (params: {
  type: number //1收费 2退费
  pageSize?: number
  medicalRecordId: number | string
}) => {
  return request.get({
    url: '/clinic/charges-records/point-list',
    params,
  })
}
// 修改收费记录的支付方式
export const updateChargeRecordPayment = (params: {
  id: number | string
  payChannelCode: string
  medicalRecordId: number | string
}) => {
  return request.put({
    url: '/clinic/charges-records/update',
    data: params,
  })
}

// 修改收费记录备注
export const updateChargeRecordRemark = (params: {
  id: number | string
  medicalRecordId: number | string
  remark: string
}) => {
  return request.put({
    url: '/clinic/charges-records/update',
    data: params,
  })
}

// 计算退费金额
export const calculateRefund = (params: {
  medicalRecordId: number
  list: Array<{
    id: number | string
    refundNum?: number
    itemList: Array<{
      itemId: number | string
      refundNum?: number
      refundAmount?: number
    }>
    payChannelCode?: string
    doctorId?: number
    doctorName?: string
    remark?: string
  }>
  refundAmount?: number
  paymentMethod?: string
  refundType?: 1 | 2
  doctorId?: number
  doctorName?: string
  remark?: string
}) => {
  return request.put({
    url: '/clinic/medical-records/calculate-refund',
    data: params,
    noErrorTip: true,
  })
}

// 退费
export const refund = (params: {
  medicalRecordId: number
  list?: Array<{
    id: number | string
    refundNum?: number
    itemList: Array<{
      itemId: number | string
      refundNum: number
    }>
  }>
  doctorId: number
  doctorName: string
  refundAmount: number
  paymentMethod: string
  refundType: 1 | 2
  remark?: string
}) => {
  return request.put({
    url: '/clinic/medical-records/refund',
    data: params,
  })
}

// 获取已收费细项详情
export const getChargeDetailCharged = (params: any) => {
  return request.get({
    url: `/clinic/medical-records/get-charge-detail-charged`,
    params,
  })
}

// 关闭收费
export const closeOrder = (params: any) => {
  return request.get({
    url: '/clinic/medical-records/closed',
    params,
  })
}

// 将已关闭的待收费单恢复为待收费
export const rechargeOrder = (id: number) => {
  return request.put({
    url: '/clinic/medical-records/recharge',
    params: { id },
  })
}

// 删除收费单
export const deleteChargeOrder = (params: any) => {
  return request.delete({
    url: '/clinic/medical-records/charge-delete',
    params,
  })
}

// 获取收费汇总统计数据
export const getChargesCount = (params: {
  startTime?: string
  endTime?: string
  myDone?: boolean | number | string
}) => {
  return request.get({
    url: '/clinic/statistics/charges-count',
    params,
  })
}

// 获取收退费记录详情
export const getChargesDetails = (params: {
  type?: number
  chargesType?: number
  patentId?: number
  visitStatus?: number
  payChannelCode?: string
  departmentId?: number
  departmentName?: string
  doctorId?: number
  doctorName?: string
  chargesUserId?: number
  chargesUserName?: string
  createTime?: string[]
  deptId?: number
  deptName?: string
  pageNo: number
  pageSize: number
}) => {
  return request.get({
    url: '/clinic/statistics/charges-details',
    params,
  })
}

// 获取医疗收费明细
export const getMedicalChargesDetails = (params: {
  pageNo: number
  pageSize: number
  startTime?: string
  endTime?: string
}) => {
  return request.get({
    url: '/clinic/statistics/medical-charges-details',
    params,
  })
}

// 导出医疗收费明细
export const getMedicalChargesDetailsExport = (params: {
  pageNo: number
  pageSize: number
  exportType?: string
  startTime?: string
  endTime?: string
}) => {
  return request.get({
    url: '/clinic/statistics/medical-charges-details-export',
    params,
  })
}

// 通联支付订单
export const createTongLianOrder = data => {
  return request.post({
    url: `/clinic/tong-lian-order/create`,
    data,
  })
}
// 通联订单状态
export const tongLianOrderDetail = params => {
  return request.get({
    url: `/clinic/tong-lian-order/get`,
    params,
  })
}
// 创建支付信息
export const createCharge = data => {
  return request.post({
    url: `/clinic/medical-records/create-charge`,
    data,
  })
}
// 更新支付信息
export const updateCharge = data => {
  return request.post({
    url: `/clinic/medical-records/update-record`,
    data,
  })
}

// 导出快递名单
export const exportExcelKuaidi = params => {
  return request.get({
    url: `/clinic/medical-record-deliveries/export-excel`,
    params,
  })
}

// 获取收费单据详情
export const getChargeReceiptDetail = (id: string | number): Promise<any> => {
  return request.get({
    url: `/clinic/charges-records/get?id=${id}`,
  })
}
